import React, { useEffect, useState } from 'react';
import InputText from '../../components/agv-forms-input';
import GenericModal from '../../components/agv-generic-modal';
import TextArea from '../../components/agv-forms-textarea';
import InputCombobox from '../../components/agv-forms-combobox/input-combobox';
import InputRadio from '../../components/agv-forms-radio';
import {
  CRITICALITIES,
  CRITICALITIES_DISPLAY_NAME,
} from '../../enums/criticalities-enum.enum';

export default function CreateReserveReasonModal({
  isOpen,
  setIsOpen,
  createReserveReason,
  mainActionIsLoading,
}) {
  const [reasonMessage, setReasonMessage] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('');
  const [criticality, setCriticality] = useState('');
  const [types, setTypes] = useState([]);

  const isEmpty =
    !reasonMessage?.length || !criticality?.length || !types?.length;

  useEffect(() => {
    if (!isOpen) {
      setReasonMessage('');
      setDescription('');
      setIcon('');
      setCriticality('');
      setTypes([]);
    }
  }, [isOpen]);

  const handleChangeSelectedTypes = (selectedType) => {
    if (selectedType.includes('ALL')) {
      selectedType = [
        'LIVRAISON',
        'REPRISE',
        'TRANSVIDAGE',
        'TRANSFERT-SILO',
      ].map((selectedType) => selectedType);
    }
    setTypes(selectedType);
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Créer une catégorie de réserve'}
      mainAction={() =>
        createReserveReason(
          reasonMessage,
          description,
          icon,
          criticality,
          types
        )
      }
      mainActionText={'Créer'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={isEmpty}
    >
      <div className="tw-flex tw-flex-col">
        <InputText
          value={reasonMessage}
          setValue={setReasonMessage}
          fieldTitle={'Nom'}
          isRequired
          emptyError={`Le champ "Nom" ne peut être vide.`}
          style={''}
          placeholder={'Nom de la catégorie'}
        />
        <TextArea
          value={description}
          setValue={setDescription}
          fieldTitle={'Description'}
          style={'tw-mt-4'}
        />
        <InputCombobox
          value={types}
          setValue={handleChangeSelectedTypes}
          placeholder={"Sélectionnez parmi les types d'étapes possibles"}
          fieldTitle={"Types d'étapes"}
          items={[
            {
              name: "Tous les types d'étapes",
              value: 'ALL',
            },
            ...['LIVRAISON', 'REPRISE', 'TRANSVIDAGE', 'TRANSFERT-SILO'].map(
              (element) => ({
                name: element,
                value: element,
              })
            ),
          ]}
          isRequired
          emptyError={`Le champ "Types d'étapes" ne peut être vide.`}
          style={'tw-mt-4'}
          isMultiple
          maxValueToDisplay={3}
        />
        <InputRadio
          value={criticality}
          setValue={setCriticality}
          fieldTitle={'Criticité'}
          items={Object.keys(CRITICALITIES).map((element) => ({
            name: CRITICALITIES_DISPLAY_NAME[element],
            value: element,
          }))}
          isRequired
          emptyError={`Le champ "Criticité" ne peut être vide.`}
          style={'tw-mt-4'}
        />
      </div>
    </GenericModal>
  );
}
